import CampaignLeadsCard from './CampaignLeadsCard'
import ConversionRateCard from './ConversionRateCard'
import OrdersClosedCard from './OrdersClosedCard'
import OrdersLostCard from './OrdersLostCard'

export default function DashboardStats({
  campaignLeads,
  conversionRate,
  ordersClosed,
  ordersLost,
  period,
  customRange,
}) {
  return (
    <section className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
      <CampaignLeadsCard
        data={campaignLeads}
        period={period}
        customRange={customRange}
      />
      <ConversionRateCard
        data={conversionRate}
        period={period}
        customRange={customRange}
      />
      <OrdersClosedCard
        data={ordersClosed}
        period={period}
        customRange={customRange}
      />
      <OrdersLostCard
        data={ordersLost}
        period={period}
        customRange={customRange}
      />
    </section>
  )
}
